<template>
  <d-form @submit.prevent="submit" class="row justify-content-center align-items-center">
    <d-col>
      <d-form-row>
        <d-col cols="12">
          <form-group v-model="d_data.email" :placeholder="$t('input.placeholder.email')"  :showLabel="false" type="email" />
        </d-col>

        <d-col cols="12">
          <form-group v-model="d_data.password" :showLabel="false">
            <template #input>
              <password-input v-model="d_data.password" :placeholder="$t('input.placeholder.password')" />
            </template>
          </form-group>
        </d-col>

        <d-col cols="6">
          <form-group v-model="d_data.remember" class="mb-0" :showLabel="false">
            <template #input>
              <d-checkbox inline v-model="d_data.remember">
                {{ $t('login.remember_me') }}
              </d-checkbox>
            </template>
          </form-group>
        </d-col>

        <d-col cols="6" class="text-right">
          <button @click.prevent="showPasswordForgotModal" class="btn btn-link p-0" type="button">
            {{ $t('login.forgot_password') }}
          </button>
        </d-col>
      </d-form-row>

      <d-form-invalid-feedback v-if="d_request.errors.has('message')" class="mt-2">
        {{ d_request.errors.get('message') }}
      </d-form-invalid-feedback>

      <d-row class="justify-content-center mt-3">
        <d-col class="col-auto">
          <r-button type="submit" :error="d_request.error" :loading="d_request.loading">
            {{ $t('button.login') }}
          </r-button>
        </d-col>
      </d-row>
    </d-col>
  </d-form>
</template>

<script>
import RedirectRequest from '@/library/RedirectRequest';
import PasswordInput from '@/components/common/form/PasswordInput';
import PasswordForgotModal from '@/components/auth/PasswordForgotModal';

export default {
  name: 'auth-login',
  components: { PasswordInput, PasswordForgotModal },
  props: {
    loginChallenge: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      d_request: new RedirectRequest(),
      d_data: {},
    };
  },
  methods: {
    submit () {
      const url = `login?login_challenge=${this.loginChallenge}`;

      this.d_request.post(url, this.d_data);
    },
    showPasswordForgotModal () {
      const options = {
        props: {
          loginChallenge: this.loginChallenge,
          email: this.d_data.email,
        },
        modalComponent: PasswordForgotModal,
      };

      const modal = this.$helpers.modal(options);

      modal.show();
    },
  },
}
</script>
